import React, {useEffect} from "react";
import {connect} from "react-redux";

import GroheSameColorFeaturesContent from "./groheSameColorFeaturesContent";
import {
  setGroheSameColorSectionOpened
} from "../../../../../actions/groheFunctions";
import withFeatureColorMatch from "../../../hocs/withFeatureColorMatch";


const GroheSameColorFeatures = (props) => {

  const {lookOpened, sameColorFeatures, currentColorFeatures, groheSameColorSectionOpened, setGroheSameColorSectionOpened,
    groheSameColorActiveFeature, shopPageOpened} = props;

  useEffect(() => {
    if (!shopPageOpened && !lookOpened && sameColorFeatures.length && groheSameColorActiveFeature) {
      setGroheSameColorSectionOpened(true) // same color but different feature groups
    } else if ((lookOpened || shopPageOpened) && groheSameColorSectionOpened) {
      setGroheSameColorSectionOpened(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookOpened, sameColorFeatures.length, shopPageOpened])

  if (!sameColorFeatures.length) {
    return null
  }

  return (
    <section className={"grohe-secondary" + (groheSameColorSectionOpened ? " grohe-secondary--opened" : "")}>
      <GroheSameColorFeaturesContent sameColorFeatures={sameColorFeatures}
                                     currentColorFeatures={currentColorFeatures}/>
    </section>
  )
};

const mapStateToProps = (store) => {
  const {lookOpened} = store.lookState;
  const {groheSameColorSectionOpened, groheSameColorActiveFeature} = store.groheState;
  const {shopPageOpened} = store.shopState;

  return {
    shopPageOpened,
    lookOpened,
    groheSameColorActiveFeature,
    groheSameColorSectionOpened,
  };
};

const mapDispatchToProps = {
  setGroheSameColorSectionOpened,
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withFeatureColorMatch(GroheSameColorFeatures)
)
